/**
 * 仓库数据维护接口api
 */
import { msiRequest } from "../../index";
import { ResultType, delType } from "../../types";
import qs from 'qs'

//api接口枚举
enum WareHoseEnum {
    //站点信息管理
    WARESITE_PAGE = '/WareSite/page',
    WARESITE_TYPE = '/WareDictData/listbycodelist',
    WARESITE_ADD = '/WareSite/add',
    WARESITE_EDIT = '/WareSite/edit',
    WARESITE_DELETE = '/WareSite/delete',
    //仓库信息管理
    WARSEHOUSEINFO_PAGE = '/WareStoreHouse/page',
    WARSEHOUSEINFO_ORG = '/sysOrg/page',//所属部门下拉框 
    WARSEHOUSEINFO_SELECT = '/WareDictData/listbycodelist',//仓库信息页面需要的下拉框数据
    WARSEHOUSEINFO_ADD = '/WareStoreHouse/add',
    WARSEHOUSEINFO_EDIT = '/WareStoreHouse/edit',
    WARSEHOUSEINFO_DELETE = '/WareStoreHouse/delete',
    //库区信息管理
    AREAINFO_PAGE = '/Area/page',
    AREAINFO_WAREHOUSE = '/Area/list',//所属库区下拉框
    AREAINFO_ADD = '/Area/add',
    AREAINFO_EDIT = '/Area/edit',
    AREAINFO_DELETE = '/Area/delete',//删除库口
    //库口信息管理
    ENTRANCE_PAGE = '/AccessMouth/page',//分页查询库口信息
    ENTRANCE_WAREHOUSE = '/AccessMouth/list',//获取库口列表
    ENTRANCE_ADD = '/AccessMouth/add',//新增库口
    ENTRANCE_EDIT = '/AccessMouth/edit',//更新库口
    ENTRANCE_DELETE = '/AccessMouth/delete',
    //货架信息管理
    SHELFINFO_PAGE = '/WareShelves/page',
    SHELFINFO_SELECT = '/WareDictData/listbycodelist',
    SHELFINFO_ADD = '/WareShelves/add',
    SHELFINFO_EDIT = '/WareShelves/edit',
    SHELFINFO_DELETE = '/WareShelves/delete',
    //库位信息管理
    STORAGEINFO_PAGE = '/WareLocation/page',
    STORAGEINFO_SELECT = '/WareDictData/listbycodelist',
    STORAGEINFO_SHELFINFO_SELECT = '/Area/list',
    STORAGEINFO_ADD = '/WareLocation/AddLocation',
    STORAGEINFO_EDIT = '/WareLocation/edit',
    STORAGEINFO_DELETE = '/WareLocation/DeleteLocation',
    WareLocation_Add = '/WareLocation/Add',
    WareLocation_BatchAdd= '/WareLocation/BatchAdd',
   
    //容器基础信息管理
    CARRIERINFO_PAGE = '/WareContainer/page',
    CARRIERINFO_SELECTED = '/WareDictData/listbycodelist',
    CARRIERINFO_ADD = '/WareContainer/add',
    CARRIERINFO_EDIT = '/WareContainer/edit',
    CARRIERINFO_DELETE = '/WareContainer/delete',
    //容器类型管理
    CARRIERTYPE_PAGE = '/WareContainerType/page',
    CARRIERTYPE_ADD = '/WareContainerType/add',
    CARRIERTYPE_EDIT = '/WareContainerType/edit',
    CARRIERTYPE_DELETE = '/WareContainerType/delete',
    //物料基础数据
    MATERIALINFO_PAGE_tag = '/GoodsDeliveryTagPrint/Page',
    MATERIALINFO_PAGE = '/WareMaterial/page',
    MATERIALINFO_ADD = '/WareMaterial/add',
    MATERIALINFO_EDIT = '/WareMaterial/edit',
    MATERIALINFO_DELETE = '/WareMaterial/delete',
    MATERIALINFO_DETAILSLIST = '/WareMaterialWarehouse/page',
    //仓库字典管理列表
    WAREHOUSEDICTIONARY_PAGE = '/WareDicType/page',
    WAREHOUSEDICTIONARY_ADD = '/WareDicType/add',//新增仓库字典
    WAREHOUSEDICTIONARY_EDIT = '/WareDicType/edit',//编辑仓库字典
    WAREHOUSEDICTIONARY_DELETE = '/WareDicType/delete',//删除仓库字典
    WAREHOUSEDICTIONARYVALUE_PAGE = '/WareDictData/page',//仓库字典值列表
    WAREHOUSEDICTIONARYVALUE_ADD = '/WareDictData/add',//仓库字典值新增
    WAREHOUSEDICTIONARYVALUE_EDIT = '/WareDictData/edit',//仓库字典值编辑
    WAREHOUSEDICTIONARYVALUE_DELETE = '/WareDictData/delete',//仓库字典值编辑
    //项目管理列表
    PROHECTLIST_PAGE = '/ProjectManage/page',
    PROHECTLIST_DELETE = '/ProjectManage/delete',
    PROHECTLIST_ADD = '/ProjectManage/add',
    PROHECTLIST_EDIT = '/ProjectManage/edit',
    // 供应商管理
    EVALUATESHOWVENDOR_PAGE = '/SupplierInfo/page',
    EVALUATESHOWVENDOR_ADD = '/SupplierInfo/add',
    EVALUATESHOWVENDOR_EDIT = '/SupplierInfo/edit',
    EVALUATESHOWVENDOR_DELETE = '/SupplierInfo/delete',
    //
    STORAGETYPE_PAGE = '/WareLocationType/page', //库位类型
    STORAGETYPE_ADD = '/WareLocationType/add',
    STORAGETYPE_EDIT = '/WareLocationType/edit',
    STORAGETYPE_DELETE = '/WareLocationType/delete',
    WARSEHOUSETYPE_PAGE = '/WareStoreHouseType/page', //仓库类型
    WARSEHOUSETYPE_ADD = '/WareStoreHouseType/add',
    WARSEHOUSETYPE_EDIT = '/WareStoreHouseType/edit',
    WARSEHOUSETYPE_DELETE = '/WareStoreHouseType/delete',
    MATERIALTYPE_PAGE = '/WareMaterialType/page', //物料类型管理
    MATERIALTYPE_ADD = '/WareMaterialType/add',
    MATERIALTYPE_EDIT = '/WareMaterialType/edit',
    MATERIALTYPE_DELETE = '/WareMaterialType/delete',
    SHELFTYPE_PAGE = '/WareShelvesType/page', //货架类型服务
    SHELFTYPE_ADD = '/WareShelvesType/add',
    SHELFTYPE_EDIT = '/WareShelvesType/edit',
    SHELFTYPE_DELETE = '/WareShelvesType/delete',
    SETLIMIT_PAGE = '/WareWaterLevel/page', //库存水位设置
    SETLIMIT_ADD = '/WareWaterLevel/add',
    SETLIMIT_EDIT = '/WareWaterLevel/edit',
    SETLIMIT_DELETE = '/WareWaterLevel/delete',
    SETAGE_PAGE = '/WareAge/page', //库龄设置
    SETAGE_ADD = '/WareAge/add',
    SETAGE_EDIT = '/WareAge/edit',
    SETAGE_DELETE = '/WareAge/delete',
    MATERIALMAXTYPE_PAGE = '/WareMaterialMaxtype/page', //物料大类
    MATERIALMAXTYPE_ADD = '/WareMaterialMaxtype/add',
    MATERIALMAXTYPE_EDIT = '/WareMaterialMaxtype/edit',
    MATERIALMAXTYPE_DELETE = '/WareMaterialMaxtype/delete',
    MATERIALINFO_TEMPLATE = '/sysFileInfo/download',
    //供应商账号--
    EVALUATESHOWVENDOR_Obtain = '/ERP/addSupplierInfo',
    //组装车间
    WareAssemblyWorkshop_PAGE = '/WareAssemblyWorkshop/page',
    WareAssemblyWorkshop_ADD = '/WareAssemblyWorkshop/add',
    WareAssemblyWorkshop_EDIT = '/WareAssemblyWorkshop/edit',
    WareAssemblyWorkshop_DELETE = '/WareAssemblyWorkshop/delete',//删除库口
}

// ----------------------------------------------------
//站点管理 -- 列表
export function getWareSiteList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.WARESITE_PAGE}?${qs.stringify(data)}`
    });
}
//站点管理 -- 站点类型下拉框
export function getWareSiteTypeList(data: any = {}) {
    return msiRequest.get({
        url: `${WareHoseEnum.WARESITE_TYPE}?${qs.stringify(data)}`
    })
}
//站点管理 -- 添加
export function addWareSite(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WARESITE_ADD,
        data
    })
}
//站点管理 -- 编辑
export function editWareSite(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WARESITE_EDIT,
        data
    })
}
//站点管理 -- 删除
export function delWareSite(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WARESITE_DELETE,
        data
    })
}

// ----------------------------------------------------
//获取仓库信息列表
export function getWarsehouseInfoList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.WARSEHOUSEINFO_PAGE}?${qs.stringify(data)}`
    });
}
export function getOrgList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.WARSEHOUSEINFO_ORG}?${qs.stringify(data)}`
    });
}
export const getWarsehouseInfoSelectList = (data: any = {}) => {
    return msiRequest.get({
        url: `${WareHoseEnum.WARSEHOUSEINFO_SELECT}?${qs.stringify(data)}`
    })
}
//添加仓库信息
export function addWarsehouseInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WARSEHOUSEINFO_ADD,
        data
    })
}
//编辑仓库信息
export function editWarsehouseInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WARSEHOUSEINFO_EDIT,
        data
    })
}
//删除仓库信息
export function delWarsehouseInfo(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WARSEHOUSEINFO_DELETE,
        data
    })
}

// ----------------------------------------------------
//库区信息管理 -- 列表
export function getAreaInfoList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.AREAINFO_PAGE}?${qs.stringify(data)}`
    });
}
// 获取下拉框数据
export function getAreaInfoWAREHOUSEList() {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.AREAINFO_WAREHOUSE}`
    })
}
//库区信息管理 -- 添加
export function addAreaInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        // url: WareHoseEnum.AREAINFO_ADD,
        url: `${WareHoseEnum.AREAINFO_ADD}?${qs.stringify(data)}`,
        data
    })
}
//库区信息管理 -- 编辑
export function editAreaInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: `${WareHoseEnum.AREAINFO_EDIT}?${qs.stringify(data)}`,
        data
    })
}
//库区信息管理 -- 删除
export function delAreaInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.AREAINFO_DELETE,
        data
    })
}

// ----------------------------------------------------
//库口信息管理 -- 列表
export function getentrance(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.ENTRANCE_PAGE}?${qs.stringify(data)}`
    });
}
// 获取下拉框数据
export function entranceList() {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.ENTRANCE_WAREHOUSE}`
    })
}
//库口信息管理 -- 添加
export function addentrance(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: `${WareHoseEnum.ENTRANCE_ADD}?${qs.stringify(data)}`,
        data
    })
}
//库口信息管理 -- 编辑
export function editentrance(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: `${WareHoseEnum.ENTRANCE_EDIT}?${qs.stringify(data)}`,
        data
    })
}
//库口信息管理 -- 删除
export function delentrance(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.ENTRANCE_DELETE,
        data
    })
}
// ------------------------------------------------------------------------

//货架类型服务 -- 列表
export function getShelfInfoList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.SHELFINFO_PAGE}?${qs.stringify(data)}`
    });
}
// 获取下拉框数据
export function getShelfInfoSelectList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.SHELFINFO_SELECT}?${qs.stringify(data)}`
    })
}
//货架类型服务 -- 添加
export function addShelfInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SHELFINFO_ADD,
        data
    })
}

//货架类型服务 -- 编辑
export function editShelfInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SHELFINFO_EDIT,
        data
    })
}

//货架类型服务 -- 删除
export function delShelfInfo(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SHELFINFO_DELETE,
        data
    })
}

// --------------------------------------------------------
//获取库位信息列表
export function getStorageInfoList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.STORAGEINFO_PAGE}?${qs.stringify(data)}`
    });
}
// 获取下拉框数据
export function getStorageInfoSelectList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.STORAGEINFO_SELECT}?${qs.stringify(data)}`
    })
}

// 获取所属库区下拉框数据
export function getStorageInfoShelvesList() {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.STORAGEINFO_SHELFINFO_SELECT}`
    })
}
//添加库位信息
export function addStorageInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.STORAGEINFO_ADD,
        data
    })
}
//创建单条库位
export function WareLocation_Add(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WareLocation_Add,
        data
    })
}

export function WareLocation_BatchAdd(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WareLocation_BatchAdd,
        data
    })
}

//编辑库位信息
export function editStorageInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.STORAGEINFO_EDIT,
        data
    })
}
//删除库位信息
export function delStorageInfo(data:any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.STORAGEINFO_DELETE,
        data
    })
}
// --------------------------------------------
//容器基础信息管理 -- 列表
export function getCarrierInfoList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.CARRIERINFO_PAGE}?${qs.stringify(data)}`
    });
}
//获取容器种类,容器材质下拉框列表
export function getCarrierInfoSelectList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.CARRIERINFO_SELECTED}?${qs.stringify(data)}`
    })
}
//容器基础信息管理 -- 添加
export function addCarrierInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.CARRIERINFO_ADD,
        data
    })
}
//容器基础信息管理 -- 编辑
export function editCarrierInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.CARRIERINFO_EDIT,
        data
    })
}
//容器基础信息管理 -- 删除
export function delCarrierInfo(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.CARRIERINFO_DELETE,
        data
    })
}
// -------------------------------------------------------------
//容器类型管理 -- 列表
export function getCarrierTypeList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.CARRIERTYPE_PAGE}?${qs.stringify(data)}`
    });
}
//容器类型管理 -- 添加
export function addCarrierType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.CARRIERTYPE_ADD,
        data
    })
}
//容器类型管理 -- 编辑
export function editCarrierType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.CARRIERTYPE_EDIT,
        data
    })
}
//容器类型管理 -- 删除
export function delCarrierType(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.CARRIERTYPE_DELETE,
        data
    })
}
//------------------------------------------------------------------------
// 物料二维码数据 -- 列表
export function getmaterialdetails(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.MATERIALINFO_PAGE_tag}?${qs.stringify(data)}`
    });
}
//物料基础数据 --- 物料模板下载
export function templateMaterial() {
    return msiRequest.post<BlobPart>({
        url: WareHoseEnum.MATERIALINFO_TEMPLATE,
        responseType: 'blob'
    })
}
// 物料基础数据 -- 列表
export function getMaterialInfoList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.MATERIALINFO_PAGE}?${qs.stringify(data)}`
    });
}
//物料基础数据 -- 添加
export function addMaterialInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.MATERIALINFO_ADD,
        data
    })
}
//物料基础数据 -- 编辑
export function editMaterialInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.MATERIALINFO_EDIT,
        data
    })
}
//物料基础数据 -- 删除
export function delMaterialInfo(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.MATERIALINFO_DELETE,
        data
    })
}
// 物料详情
export function getMaterialDetailsInfoList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.MATERIALINFO_DETAILSLIST}?${qs.stringify(data)}`
    });
}
// ---------------------------------------------------------------
// 仓库字典管理列表
export function getWarsehouseDicTypeList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.WAREHOUSEDICTIONARY_PAGE}?${qs.stringify(data)}`
    });
}
//添加仓库字典
export function addWarsehouseDicTypeList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WAREHOUSEDICTIONARY_ADD,
        data
    })
}
//添加仓库字典
export function editWarsehouseDicTypeList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WAREHOUSEDICTIONARY_EDIT,
        data
    })
}
// 删除仓库字典
export function deleteWarsehouseDicTypeList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WAREHOUSEDICTIONARY_DELETE,
        data
    })
}
// 仓库字典值列表
export function getWarsehouseDicValueList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.WAREHOUSEDICTIONARYVALUE_PAGE}?${qs.stringify(data)}`
    });
}
//添加仓库字典
export function addWarsehouseDicValueList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WAREHOUSEDICTIONARYVALUE_ADD,
        data
    })
}
//添加仓库字典
export function editWarsehouseDicValueList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WAREHOUSEDICTIONARYVALUE_EDIT,
        data
    })
}
// 删除仓库字典
export function deleteWarsehouseDicValueList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WAREHOUSEDICTIONARYVALUE_DELETE,
        data
    })
}
// ---------------------------------------------------------------

// 项目管理列表
export function getProjectList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.PROHECTLIST_PAGE}?${qs.stringify(data)}`
    })
}
// 项目管理--删除
export function deleteProjectList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.PROHECTLIST_DELETE,
        data
    })
}
// 项目管理--新增
export function addProjectList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.PROHECTLIST_ADD,
        data
    })
}
// 项目管理--编辑
export function editProjectList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.PROHECTLIST_EDIT,
        data
    })
}
// ---------------------------------------------------------------
// 供应商管理 -- 列表
export function getEvaluatesHowVendorList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.EVALUATESHOWVENDOR_PAGE}?${qs.stringify(data)}`
    })
}
// 供应商管理--新增
export function addEvaluatesHowVendorList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.EVALUATESHOWVENDOR_ADD,
        data
    })
}
// 供应商管理--编辑
export function editEvaluatesHowVendorList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.EVALUATESHOWVENDOR_EDIT,
        data
    })
}
// 供应商管理--删除
export function deleteEvaluatesHowVendorList(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.EVALUATESHOWVENDOR_DELETE,
        data
    })
}
//供应商账号--获取

export function addSupplierInfo(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.EVALUATESHOWVENDOR_Obtain,
        data
    })
}
// ----------------------------------------------------
//组装车间 -- 列表
export function WareAssemblyWorkshop(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.WareAssemblyWorkshop_PAGE}?${qs.stringify(data)}`
    });
}
//组装车间 -- 添加
export function WareAssemblyWorkshop_add(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: `${WareHoseEnum.WareAssemblyWorkshop_ADD}?${qs.stringify(data)}`,
        data
    })
}
//组装车间 -- 编辑
export function WareAssemblyWorkshop_edit(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: `${WareHoseEnum.WareAssemblyWorkshop_EDIT}?${qs.stringify(data)}`,
        data
    })
}
//组装车间 -- 删除
export function WareAssemblyWorkshop_del(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WareAssemblyWorkshop_DELETE,
        data
    })
}

// ----------------------------------------------------





































//物料大类 -- 列表
export function getMaterialMaxTypePage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.MATERIALMAXTYPE_PAGE}?${qs.stringify(data)}`
    });
}

//物料大类 -- 添加
export function addMaterialMaxType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.MATERIALMAXTYPE_ADD,
        data
    })
}

//物料大类 -- 编辑
export function editMaterialMaxType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.MATERIALMAXTYPE_EDIT,
        data
    })
}

//物料大类 -- 删除
export function delMaterialMaxType(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.MATERIALMAXTYPE_DELETE,
        data
    })
}



// -----------------------------------------------------------------
//库存水位设置 -- 列表
export function getSetAgeList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.SETAGE_PAGE}?${qs.stringify(data)}`
    });
}

//库存水位设置 -- 添加
export function addSetAge(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SETAGE_ADD,
        data
    })
}

//库存水位设置 -- 编辑
export function editSetAge(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SETAGE_EDIT,
        data
    })
}

//库存水位设置 -- 删除
export function delSetAge(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SETAGE_DELETE,
        data
    })
}
// -------------------------------------------------------
//库存水位设置 -- 列表
export function getSetLimitList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.SETLIMIT_PAGE}?${qs.stringify(data)}`
    });
}

//库存水位设置 -- 添加
export function addSetLimit(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SETLIMIT_ADD,
        data
    })
}

//库存水位设置 -- 编辑
export function editSetLimit(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SETLIMIT_EDIT,
        data
    })
}

//库存水位设置 -- 删除
export function delSetLimit(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SETLIMIT_DELETE,
        data
    })
}


//货架类型服务 -- 列表
export function getShelfTypeList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.SHELFTYPE_PAGE}?${qs.stringify(data)}`
    });
}

//货架类型服务 -- 添加
export function addShelfType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SHELFTYPE_ADD,
        data
    })
}

//货架类型服务 -- 编辑
export function editShelfType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SHELFTYPE_EDIT,
        data
    })
}

//货架类型服务 -- 删除
export function delShelfType(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.SHELFTYPE_DELETE,
        data
    })
}




//物料类型管理 -- 列表
export function getMaterialTypeList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.MATERIALTYPE_PAGE}?${qs.stringify(data)}`
    });
}

//物料类型管理 -- 添加
export function addMaterialType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.MATERIALTYPE_ADD,
        data
    })
}

//物料类型管理 -- 编辑
export function editMaterialType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.MATERIALTYPE_EDIT,
        data
    })
}

//物料类型管理 -- 删除
export function delMaterialType(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.MATERIALTYPE_DELETE,
        data
    })
}




//获取库位类型列表
export function getStorageTypeList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.STORAGETYPE_PAGE}?${qs.stringify(data)}`
    });
}

//添加库位类型
export function addStorageType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.STORAGETYPE_ADD,
        data
    })
}

//编辑库位类型
export function editStorageType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.STORAGETYPE_EDIT,
        data
    })
}

//删除库位类型
export function delStorageType(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.STORAGETYPE_DELETE,
        data
    })
}



//获取仓库类型列表
export function getWarsehouseTypeList(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.WARSEHOUSETYPE_PAGE}?${qs.stringify(data)}`
    });
}

//添加仓库类型
export function addWarsehouseType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WARSEHOUSETYPE_ADD,
        data
    })
}

//编辑仓库类型
export function editWarsehouseType(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WARSEHOUSETYPE_EDIT,
        data
    })
}

//删除仓库类型
export function delWarsehouseType(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WARSEHOUSETYPE_DELETE,
        data
    })
}


//库位批量锁定
export function mulLockLocations(data: any) {
    return msiRequest.post<ResultType<any>>({
        url: '/WareLocation/AddLock',
        data
    })
}

//库位批量解锁
export function mulunlockLocations(data: any) {
    return msiRequest.post<ResultType<any>>({
        url: '/WareLocation/DelLock',
        data
    })
}







